import { Model } from "vuex-fetch-factory";
import { ContactRaw, ContactModel } from "./contact";
import { AddressRaw, AddressModel } from "./address";

export interface OrganisationRaw {
  id: number;
  name: string;
  email_address: string;
  phone_number: string;
  mobile_phone_number: string;
  main_contact: number;
  relation_admin: string;
  contacts: ContactRaw[];
  addresses: AddressRaw[];
}

export class OrganisationModel
  implements Model<OrganisationModel, OrganisationRaw>
{
  public id = 0;
  public name = "";
  public email_address = "";
  public phone_number = "";
  public mobile_phone_number = "";
  public main_contact = 0;
  public relation_admin = "";
  public contacts: ContactModel[] = [];
  public addresses: AddressModel[] = [];

  public getNew(): OrganisationModel {
    return new OrganisationModel();
  }

  public fillModel(raw: OrganisationRaw): this {
    this.id = raw.id;
    this.name = raw.name;
    this.email_address = raw.email_address;
    this.phone_number = raw.phone_number;
    this.mobile_phone_number = raw.mobile_phone_number;
    this.main_contact = raw.main_contact;
    this.relation_admin = raw.relation_admin;

    raw.contacts.forEach((c): void => {
      const model = new ContactModel();
      model.fillModel(c);
      this.contacts.push(model);
    });
    raw.addresses.forEach((c): void => {
      const model = new AddressModel();
      model.fillModel(c);
      this.addresses.push(model);
    });
    return this;
  }

  public getRaw(): OrganisationRaw {
    return {
      id: this.id,
      name: this.name,
      email_address: this.email_address,
      phone_number: this.phone_number,
      mobile_phone_number: this.mobile_phone_number,
      main_contact: this.main_contact,
      relation_admin: this.relation_admin,
      contacts: this.contacts.map((cm): ContactRaw => cm.getRaw()),
      addresses: this.addresses.map((cm): AddressRaw => cm.getRaw()),
    };
  }
}
